export default "/images/vendor/flag-icon-css/flags/4x3/mq.svg?df0d7ef139caab67f17c1a3605087555";